import { createContext, useContext } from "react";
import type { ThemePreset } from "./types";

type ThemePresetContextValue = {
  preset: ThemePreset;
  setPreset: (value: ThemePreset) => void;
};

const ThemePresetContext = createContext<ThemePresetContextValue | null>(null);

export const ThemePresetProvider = ThemePresetContext.Provider;

export const useThemePreset = () => {
  const context = useContext(ThemePresetContext);
  if (!context) {
    throw new Error("useThemePreset must be used within ThemePresetProvider");
  }
  return context;
};
